import { render, staticRenderFns } from "./Diet.vue?vue&type=template&id=0644fd18&"
import script from "./Diet.vue?vue&type=script&lang=js&"
export * from "./Diet.vue?vue&type=script&lang=js&"
import style0 from "./Diet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports